<script lang="ts">
    import { Splide, SplideSlide } from "@splidejs/svelte-splide"
    import { onMount } from "svelte"

    import "@splidejs/svelte-splide/css"
    import HomePageSliderSlide from "./HomePageSliderSlide.svelte"

    export let slides: HomePageTeaserSlide[]
    let main: Splide
    let nav: Splide
    const speed = 5000
    let progressWidth = 0
    let lastTime = 0
    let isPaused = false

    function updateProgressBar(e: CustomEvent<Splide>) {
        const splide = e.detail.splide

        const progressBar = document.querySelectorAll(".splide-progress-bar")

        progressBar.forEach((bar, index) => {
            const element = bar as HTMLElement
            if (index === splide.index) {
                element.style.transition = `width ${isPaused ? speed * (1 - progressWidth / 100) : speed}ms ease-out`
                element.style.width = "100%"
                isPaused = false
            } else {
                element.style.transition = `width 0ms ease-out`
                element.style.width = "0%"
            }
        })
    }

    function pauseProgressbar(e: CustomEvent<Splide>) {
        const splide = e.detail.splide
        const progressBar = document.querySelectorAll(".splide-progress-bar")[splide.index] as HTMLElement
        const computedStyle = getComputedStyle(progressBar)
        progressWidth = (parseFloat(computedStyle.width) / progressBar.parentElement.offsetWidth) * 100
        progressBar.style.transition = "none"
        progressBar.style.width = `${progressWidth}%`
        lastTime = Date.now()
        isPaused = true
    }

    function playProgressbar(e: CustomEvent<Splide>) {
        const splide = e.detail.splide
        const progressBar = document.querySelectorAll(".splide-progress-bar")[splide.index] as HTMLElement
        if (progressBar) {
            progressBar.style.transition = `width ${speed}ms linear`
            progressBar.style.width = "100%"
            isPaused = false
        }
    }

    function nextSlide() {
        if (nav) {
            nav.go(">")
            handleManualNavigation()
        }
    }

    function prevSlide() {
        if (nav) {
            nav.go("<")
            handleManualNavigation()
        }
    }

    function handleManualNavigation() {
        if (main) {
            main.Components.Autoplay.play()
            resetProgressBar()
        }
    }

    function resetProgressBar() {
        const progressBar = document.querySelectorAll(".splide-progress-bar")
        progressBar.forEach((bar) => {
            const element = bar as HTMLElement
            element.style.transition = "none"
            element.style.width = "0%"
        })
        lastTime = Date.now()
        isPaused = false
    }

    onMount(() => {
        if (main && nav) main.sync(nav.splide)
    })
</script>

<Splide
    bind:this="{nav}"
    on:moved="{updateProgressBar}"
    on:mounted="{updateProgressBar}"
    on:autoplayPause="{pauseProgressbar}"
    on:autoplayPlay="{playProgressbar}"
    options="{{
        type: 'slide',
        loop: true,
        pagination: false,
        rewind: true,
        direction: 'ltr',
        'auto-height': true,
        width: '100%',
        autoplay: true,
        interval: speed,
        arrows: false,
        gap: '2px',
    }}"
    aria-label="..."
>
    {#each slides || [] as slide}
        <SplideSlide>
            <HomePageSliderSlide {slide} on:next="{() => nextSlide()}" on:prev="{() => prevSlide()}" />
        </SplideSlide>
    {/each}
</Splide>

<style lang="less">
    :global .splide {
        border: none !important;
        .splide__slide {
            border: none !important;
        }
    }
</style>
